export const quotationPages = {
  root: {
    name: '/quotation/:id',
    navigate: (id: number) => `/quotation/${id}`,
  },
}
